var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"head"},[_c('h1',{staticClass:"title-404"},[_vm._v("404")]),_c('div',{staticClass:"subtitle-404"},[_vm._v("Ошибка! Страница не найдена")]),_c('div',{staticClass:"link-404"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Вернуться на главную")])])])])
}]

export { render, staticRenderFns }